














import { Component, Prop, Vue } from "vue-property-decorator"
import { Dispatch } from "../models/dispatch"
import marked from "marked"

@Component
export default class Event extends Vue {
    // Decorators: https://github.com/kaorun343/vue-property-decorator
    // Class: https://github.com/vuejs/vue-class-component
    @Prop(String) protected readonly headline!: string
    @Prop(String) protected readonly type!: string
    @Prop(String) private readonly body!: string
    @Prop(Array) private readonly dispatches?: Dispatch[]

    constructor() {
        super()
    }

    get content() {
        if (this.body) {
            return marked(this.body)
        } else {
            return ""
        }
    }

    protected dismiss(): void {
        if (this.dispatches) {
            for (const dis of this.dispatches) {
                this.$store.dispatch(dis.name, dis.payload)
            }
        }
        // if (this.type === "turn") {
        //     this.$store.dispatch("beginRound")
        // }
        this.$store.dispatch("dismissEvent")
    }
}
